export default "__VITE_ASSET__MjpRPWC2__"